import React from "react";
import styled from "styled-components";
import Box, { BoxProps } from "onnit-ui/lib/box/Box";
import Text from "onnit-ui/lib/text";
import Grid from "onnit-ui/lib/module/grid/12/Grid";

const Container = styled(Box)<BoxProps>`
    background-image: url("https://scdn.onnit.com/images/product-page/sports-nutrition/shared/wreath.svg");
    background-repeat: no-repeat;
    background-color: black;
    background-position: center top 10%;
    background-size: 60% auto;
    @media (min-width: 960px) {
        background-position: center top 25%;
        background-size: 45% auto;
    }
    @media (min-width: 1600px) {
        background-size: 35% auto;
    }
    .cls-1 {
        fill: #fff;
    }
    .cls-2 {
        fill: #0d0802;
    }
`;

const InformedSport: React.FC<BoxProps> = (props) => {
    return (
        <Container {...props} px={4} py={[6, 6, 6, 8]}>
            <Box width="100%" maxWidth="140px" mx="auto">
                <svg viewBox="0 0 356.83 407.58" width="100%">
                    <title>Informed Sport</title>
                    <path
                        className="cls-1"
                        d="M102.91,352a2,2,0,0,0-2.25-2.24h-9.5A2,2,0,0,0,88.91,352v4.49c0,1.45.79,1.91,2.25,2.24l12.27,2.64c5.15,1.12,9.51,4.23,9.51,9.51v8.58a8.94,8.94,0,0,1-9.37,9.37H88.78a8.94,8.94,0,0,1-9.37-9.37v-6.07h9.24v4.22a2,2,0,0,0,2.24,2.24h10.3a2,2,0,0,0,2.24-2.24v-5c0-1.45-.79-1.91-2.24-2.24l-12.28-2.64c-5.15-1.12-9.5-4.23-9.5-9.51v-8.05a8.94,8.94,0,0,1,9.37-9.37h14a8.94,8.94,0,0,1,9.38,9.37v5.55h-9.24Z"
                    />
                    <path
                        className="cls-1"
                        d="M144.92,341a8.94,8.94,0,0,1,9.38,9.38v12a8.94,8.94,0,0,1-9.38,9.37H130.14v16.77h-9.51V341Zm-2.37,21.78a2,2,0,0,0,2.24-2.24v-8.32a2,2,0,0,0-2.24-2.24H130.14v12.8Z"
                    />
                    <path
                        className="cls-1"
                        d="M185.89,340.74a8.94,8.94,0,0,1,9.37,9.37v29.31a8.94,8.94,0,0,1-9.37,9.37H170a8.94,8.94,0,0,1-9.37-9.37V350.11a8.94,8.94,0,0,1,9.37-9.37ZM185.76,352a2,2,0,0,0-2.25-2.24H172.36a2,2,0,0,0-2.25,2.24v25.61a2,2,0,0,0,2.25,2.24h11.15a2,2,0,0,0,2.25-2.24Z"
                    />
                    <path
                        className="cls-1"
                        d="M228.18,388.53l-7.66-17.63h-7.65v17.63h-9.51V341h24.23a8.94,8.94,0,0,1,9.37,9.38v11.15c0,4.49-2.51,7.86-6.47,9l7.92,18Zm-.73-36.31a2,2,0,0,0-2.24-2.24H212.87v12.08h12.34a2,2,0,0,0,2.24-2.25Z"
                    />
                    <path className="cls-1" d="M265,349.85v38.68h-9.51V349.85H243.1V341h34.33v8.85Z" />
                    <circle className="cls-1" cx="178.42" cy="168.79" r="150" />
                    <path
                        className="cls-1"
                        d="M267.41,168.79a89,89,0,1,1-89-89A89,89,0,0,1,267.41,168.79Zm-89-145.16A145.16,145.16,0,1,0,323.58,168.79,145.16,145.16,0,0,0,178.42,23.63Z"
                    />
                    <path
                        className="cls-2"
                        d="M323.58,168.79a145.16,145.16,0,0,1-290.32,0H89.43a88.57,88.57,0,0,0,15.93,50.81L180,145l-68.06-13.31H234l-83,58L192.7,202l-11.42-23.77,17.86-12.47,10.26,54.52-58.59-30.57-44.57,31.12a89,89,0,0,0,161.17-52.07Z"
                    />
                    <path className="cls-2" d="M245.21,123.71h-44l21.91-21.92A80.53,80.53,0,0,1,245.21,123.71Z" />
                    <path className="cls-2" d="M44.56,145l1.55-7.49,37.45,7.71L82,152.72Z" />
                    <path
                        className="cls-2"
                        d="M67.5,88.88l33.25,18.88-4.07,7.16-29.62-.64,22.67,12.88-3.54,6.23L53,114.5,57,107.35l29.62.64L64,95.11Z"
                    />
                    <path
                        className="cls-2"
                        d="M84.94,69.53,104.5,53.94l4.5,5.64L95.42,70.41l5.1,6.39,11-8.77,4.5,5.65-11,8.77,9.73,12.21-6,4.77Z"
                    />
                    <path
                        className="cls-2"
                        d="M142.69,37.28a7.19,7.19,0,0,1,9.49,4.86l7.26,22.43a7.18,7.18,0,0,1-4.86,9.49L142.4,78a7.18,7.18,0,0,1-9.49-4.85l-7.25-22.43a7.19,7.19,0,0,1,4.85-9.5Zm2.67,8.63a1.62,1.62,0,0,0-2.27-1.17l-8.54,2.76a1.63,1.63,0,0,0-1.16,2.28l6.34,19.6A1.62,1.62,0,0,0,142,70.54l8.54-2.76a1.62,1.62,0,0,0,1.16-2.27Z"
                    />
                    <path
                        className="cls-2"
                        d="M192.2,71.88,187.07,57.3l-6.15-.44-1,14.14-7.62-.55L175,32.32l19.44,1.39a7.19,7.19,0,0,1,7,8.06l-.64,8.95a7.11,7.11,0,0,1-5.7,6.83l5.32,14.91Zm1.5-29.18A1.62,1.62,0,0,0,192,40.78l-9.91-.71-.69,9.69,9.9.71a1.62,1.62,0,0,0,1.93-1.67Z"
                    />
                    <path
                        className="cls-2"
                        d="M241.47,92l-6.33-3.48,12.29-22.33-16.6,13L226,76.51l2.08-21L215.79,77.87l-6.33-3.48,18.42-33.51,7.36,4-2.15,24.4,19.46-14.88,7.35,4.05Z"
                    />
                    <path
                        className="cls-2"
                        d="M294.7,97.21,289,101.58,278.44,87.75l-6.26,4.76,8.52,11.2-5.76,4.37-8.51-11.2-6.93,5.27L270,116l-5.75,4.38-15.13-19.92,30.44-23.14Z"
                    />
                    <path
                        className="cls-2"
                        d="M311,137.94a7.19,7.19,0,0,1-5.18,9.32l-22.27,6.35a7.2,7.2,0,0,1-9.32-5.19l-5.46-19.15,36.77-10.49ZM280.6,144.6a1.62,1.62,0,0,0,2.23,1.24l19.41-5.53a1.63,1.63,0,0,0,1.24-2.23l-2.84-10-22.88,6.52Z"
                    />
                    <polygon
                        className="cls-1"
                        points="78.23 209.89 64.93 211.58 76.48 204.45 75.45 201.25 61.91 202.18 73.7 195.81 72.31 191.49 55.19 202.1 56.45 206 68.7 205.18 58.27 211.66 59.47 215.41 79.56 214.06 78.23 209.89"
                    />
                    <polygon
                        className="cls-1"
                        points="79.58 221.81 83.76 229.42 87.3 227.48 81.08 216.14 63.94 225.55 70.17 236.88 73.7 234.94 69.53 227.33 72.97 225.44 76.36 231.61 79.89 229.66 76.51 223.5 79.58 221.81"
                    />
                    <polygon
                        className="cls-1"
                        points="101.37 250.82 104.29 248.11 94.76 237.83 94.62 237.68 91.7 240.38 95.09 244.04 83.83 254.48 83.68 254.62 86.57 257.74 97.98 247.16 101.37 250.82"
                    />
                    <polygon
                        className="cls-1"
                        points="107.78 256.27 114.59 261.65 117.1 258.49 106.96 250.47 94.83 265.8 104.97 273.82 107.48 270.65 100.67 265.26 103.11 262.18 108.62 266.55 111.13 263.38 105.61 259.02 107.78 256.27"
                    />
                    <path
                        className="cls-1"
                        d="M128.42,265l-4.92-2.74a3.8,3.8,0,0,0-5.41,1.54l-1.58,2.83c-1,1.73-.4,3.77,1.52,5.46l3.79,3.34c.44.39.51.6.31,1l-1,1.76a.73.73,0,0,1-.4.38.76.76,0,0,1-.54-.11l-3.61-2a.73.73,0,0,1-.38-.4.76.76,0,0,1,.11-.54l.93-1.67-3.62-2-1.29,2.32a3.81,3.81,0,0,0,1.54,5.42l5.19,2.9a4.2,4.2,0,0,0,2.07.57,3.63,3.63,0,0,0,1-.14,4,4,0,0,0,2.37-2l1.68-3c1-1.73.4-3.77-1.52-5.47l-3.79-3.33c-.44-.4-.51-.6-.31-1l.88-1.57a.72.72,0,0,1,.41-.37.68.68,0,0,1,.53.1l3.34,1.87a.68.68,0,0,1,.37.4.7.7,0,0,1-.1.54l-.83,1.48,3.62,2,1.19-2.13A3.83,3.83,0,0,0,128.42,265Z"
                    />
                    <polygon
                        className="cls-1"
                        points="133.48 272.21 138.17 273.92 132.84 288.54 136.83 290 142.16 275.38 146.85 277.09 148.22 273.35 134.84 268.47 133.48 272.21"
                    />
                    <path
                        className="cls-1"
                        d="M163.69,282.73l-3.89-.57a1.22,1.22,0,0,0-1.39,1l-.57,3.89a1.29,1.29,0,0,0,.23.91,1.24,1.24,0,0,0,.81.48l3.89.57h.17a1.23,1.23,0,0,0,1.21-1.05l.57-3.89A1.22,1.22,0,0,0,163.69,282.73Z"
                    />
                    <polygon
                        className="cls-1"
                        points="185.22 285.06 181.3 277.4 176.64 277.67 183.38 290.07 183.77 296.84 188.01 296.6 187.62 289.83 192.77 277.05 192.9 276.74 188.24 277.01 185.22 285.06"
                    />
                    <path
                        className="cls-1"
                        d="M210,277a3.8,3.8,0,0,0-4.75-3l-6.25,1.4a3.81,3.81,0,0,0-3,4.76l2.58,11.5a4,4,0,0,0,1.71,2.56,3.84,3.84,0,0,0,2,.57,4.42,4.42,0,0,0,1-.12l6.24-1.4a3.79,3.79,0,0,0,3-4.75Zm-2.25,12.53-4.38,1a.74.74,0,0,1-.54-.05.76.76,0,0,1-.28-.48l-2.25-10.05a.6.6,0,0,1,.52-.82l4.38-1,.23,0a.51.51,0,0,1,.31.08.67.67,0,0,1,.28.47l2.26,10.05A.6.6,0,0,1,207.71,289.52Z"
                    />
                    <path
                        className="cls-1"
                        d="M225.67,267l-.08-.2-3.93,1.61,5.64,13.82a.61.61,0,0,1-.38.9L223,284.7a.69.69,0,0,1-.54,0,.7.7,0,0,1-.36-.42l-5.56-13.62-.08-.19-3.93,1.6,5.92,14.51a4,4,0,0,0,2.12,2.24,3.56,3.56,0,0,0,1.42.28,4.36,4.36,0,0,0,1.66-.34l5.65-2.31a3.8,3.8,0,0,0,2.18-5.19Z"
                    />
                    <polygon
                        className="cls-1"
                        points="250.63 255.15 248.25 251.96 237 260.33 236.83 260.45 239.21 263.65 243.22 260.67 252.38 272.99 252.5 273.16 255.91 270.62 246.63 258.13 250.63 255.15"
                    />
                    <path
                        className="cls-1"
                        d="M266.62,245.6l-3.22-3.13a3.81,3.81,0,0,0-5.63.08l-6.95,7.13,14,13.63,3-3-5.08-4.95,1.9-1.95,7.1,2.69.13.05,3.19-3.28L267.54,250A3.8,3.8,0,0,0,266.62,245.6Zm-3.45,3.54-3.32,3.41-3.17-3.1,3.31-3.4a.71.71,0,0,1,.49-.25.64.64,0,0,1,.49.24l2.19,2.12A.61.61,0,0,1,263.17,249.14Z"
                    />
                    <path
                        className="cls-1"
                        d="M283.75,234.27l-12.69-8.82-.17-.12-2.43,3.49,12.25,8.51a.68.68,0,0,1,.33.44.7.7,0,0,1-.15.52l-2.4,3.45a.72.72,0,0,1-.43.33.76.76,0,0,1-.53-.16l-12.07-8.4-.18-.12-2.42,3.49,12.86,8.94a4.11,4.11,0,0,0,2.36.78,3.35,3.35,0,0,0,.63,0,4,4,0,0,0,2.55-1.73l3.49-5a4,4,0,0,0,.72-3A4,4,0,0,0,283.75,234.27Z"
                    />
                    <path
                        className="cls-1"
                        d="M292.83,216.35l-3.12-1.49c-1.79-.85-3.79-.15-5.35,1.88l-3.08,4c-.37.46-.57.54-.95.36l-1.62-.77a.68.68,0,0,1-.4-.38.72.72,0,0,1,.07-.54L280,216a.61.61,0,0,1,.92-.33l1.53.73,1.78-3.74-2.2-1.05a3.81,3.81,0,0,0-5.31,1.89l-2.42,5.08a3.81,3.81,0,0,0,1.89,5.31l2.92,1.39c1.79.84,3.79.15,5.36-1.88l3.08-4c.36-.46.57-.55.94-.36l1.82.86a.61.61,0,0,1,.33.92l-1.78,3.74a.61.61,0,0,1-.92.33l-1.73-.82-1.77,3.74,2.39,1.14a4.39,4.39,0,0,0,1.85.44,3.81,3.81,0,0,0,3.46-2.33l2.55-5.37A3.8,3.8,0,0,0,292.83,216.35Z"
                    />
                    <polygon
                        className="cls-1"
                        points="286.16 199.08 287.56 194.29 283.74 193.17 279.81 206.63 279.75 206.84 283.57 207.95 284.97 203.16 299.71 207.46 299.91 207.52 301.1 203.44 286.16 199.08"
                    />
                </svg>
            </Box>
            <Grid>
                <Box gridColumn={["1 / -1", "1 / -1", "3 / span 8"]}>
                    <Text
                        color="white"
                        fontWeight="bold"
                        fontSize={[4, 8, 9]}
                        textAlign={"center"}
                        letterSpacing={3}
                        my={[4, 4, 6]}
                        textTransform="uppercase"
                    >
                        Informed Sport Certified
                    </Text>
                    <Text color="white" as="p" mb={5} typeStyle="copy02" textAlign={"center"}>
                        Onnit is committed to the highest standards of quality and efficacy. We have already had many of
                        our products independently certified to be competition safe, and we're actively pursuing even
                        more certifications.
                    </Text>
                    <Text color="white" as="p" mb={5} typeStyle="copy02" textAlign={"center"}>
                        Informed Sport is a third-party testing program developed by the world-class anti-doping
                        laboratory, LGC. It is widely regarded as the global gold standard for banned-substances testing
                        in sports nutrition products. Each lot of Onnit products bearing the Informed Sport logo has
                        been rigorously tested for banned substances by the Informed Sport program before it is released
                        for sale.
                    </Text>
                </Box>
            </Grid>
        </Container>
    );
};

export default InformedSport;
